const AdminProjectType = {
    Diagnostics: 0,
    Jobmatch: 2,
    P360: 360,
    Spokojenost: 4,
} as const;

export default AdminProjectType;
